module.exports = __webpack_public_path__ + "images/emoji/scissors.77f13b63a409af0ff0db.png";